import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../helpers/spacing';
import { GridItem } from '../../Grid';

const getWidthCalculation = (
  numberOfItems: number,
  gutterPx: number,
  isLast: boolean
): string => {
  // 1px border + padding + margin
  const totalGutters = (1 + gutterPx + gutterPx) * (numberOfItems - 1);
  return isLast
    ? `calc((100% - ${totalGutters}px) / ${numberOfItems})`
    : `calc(((100% - ${totalGutters}px) / ${numberOfItems}) + ${gutterPx}px + 1px)`;
};

export const InfoCardContainer = styled.div<{ numberOfItems: number }>`
  &:not(:last-child) {
    padding-bottom: ${spacingWithBorder(3, 1)};
    margin-bottom: ${spacingWithBorder(3, 1)};
    border-bottom: 1px solid ${colors.cardBorder};

    ${({ numberOfItems }) => mediaQuery.tabletPortrait`
      margin-bottom: 0;
      padding-bottom: ${spacing(2)};
      padding-left: ${spacing(4)};
      border-bottom: 0;
      border-right: 1px solid ${colors.cardBorder};
      margin-right: ${({ theme }) => theme.layout.tabletPortrait.gutterPx}px;
      padding-right: ${({ theme }) => theme.layout.tabletPortrait.gutterPx}px;
      width: ${({ theme }) =>
        getWidthCalculation(numberOfItems, theme.layout.tabletPortrait.gutterPx, false)};
    `}

    ${({ numberOfItems }) => mediaQuery.tabletLandscape`
      padding-bottom: 0;
      padding-left: 0;
      margin-right: ${({ theme }) => theme.layout.tabletLandscape.gutterPx}px;
      padding-right: ${({ theme }) => theme.layout.tabletLandscape.gutterPx}px;
      width: ${({ theme }) =>
        getWidthCalculation(numberOfItems, theme.layout.tabletLandscape.gutterPx, false)};
    `}

    ${({ numberOfItems }) => mediaQuery.desktop`
      margin-right: ${({ theme }) =>
        theme.layout.desktop.gutterPx + 2 * theme.layout.baseSpacingPx}px;
      padding-right: ${({ theme }) =>
        theme.layout.desktop.gutterPx + 2 * theme.layout.baseSpacingPx}px;
      width: ${({ theme }) =>
        getWidthCalculation(
          numberOfItems,
          theme.layout.desktop.gutterPx + 2 * theme.layout.baseSpacingPx,
          false
        )};
    `};
  }

  &:last-child {
    ${({ numberOfItems }) => mediaQuery.tabletPortrait`
      padding-bottom: ${spacing(2)};
      padding-left: ${spacing(4)};
      width: ${({ theme }) =>
        getWidthCalculation(numberOfItems, theme.layout.tabletPortrait.gutterPx, true)};
    `};

    ${({ numberOfItems }) => mediaQuery.tabletLandscape`
      padding-bottom: 0;
      padding-left: 0;
      width: ${({ theme }) =>
        getWidthCalculation(numberOfItems, theme.layout.tabletLandscape.gutterPx, true)};
    `};

    ${({ numberOfItems }) => mediaQuery.desktop`
      width: ${({ theme }) =>
        getWidthCalculation(
          numberOfItems,
          theme.layout.desktop.gutterPx + 2 * theme.layout.baseSpacingPx,
          true
        )};
    `};
  }

  &:first-child {
    ${mediaQuery.tabletPortrait`
      padding-left: ${spacing(2)};
    `}
  }
`;

export const EvenlySplitInfoCardGridItem = styled(GridItem)`
  border: 1px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};
  padding: ${spacingWithBorder(4, 1)} ${spacingWithBorder(3, 1)};
  display: flex;
  flex-direction: column;

  ${mediaQuery.tabletLandscape`
    padding: ${spacingWithBorder(4, 1)};
  `};

  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};

    ${mediaQuery.tabletLandscape`
      margin-top: ${spacing(6)};
      margin-bottom: ${spacing(6)};
    `}
  }
`;

export const Heading = styled.h3`
  ${fonts.headingXSmall}
  margin: 0 0 ${spacing(3)};
`;

export const InfoCardsContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQuery.tabletLandscape`
    flex-direction: row;
  `};
`;
